export const UNIT_TYPE_WEEK = 'week';
export const UNIT_TYPE_WEEKEND = 'weekend';

export const PRICING_TYPE_WEEKLY = 'weekly';
export const PRICING_TYPE_WEEKEND = 'weekend';

export const pricingTypeForUnitType = unitType => {
  if (unitType === UNIT_TYPE_WEEK) {
    return PRICING_TYPE_WEEKLY;
  } else if (unitType === UNIT_TYPE_WEEKEND) {
    return PRICING_TYPE_WEEKEND;
  }
  return null;
};

export const displayUnitTypeForPublicData = publicData => {
  const { pricingType, unitType } = publicData || {};

  if (pricingType === PRICING_TYPE_WEEKLY) {
    return UNIT_TYPE_WEEK;
  } else if (pricingType === PRICING_TYPE_WEEKEND) {
    return UNIT_TYPE_WEEKEND;
  }
  return unitType;
};

export const isWeeklyOrWeekendUnitType = unitType =>
  unitType === UNIT_TYPE_WEEK || unitType === UNIT_TYPE_WEEKEND;
